<template>
  <div>
    <page-header
      icon="mdi-chart-areaspline"
      :title="$t('routes.statistics')"
      :subtitle="$t('statistics_restaurant_subtitle')"
    />

    <page-toolbar :searchable="false">
      <template #filters>
        <v-col cols="6" lg="auto">
          <date-picker v-model="date" color="white" />
        </v-col>

        <v-col cols="6" lg="auto">
          <dropdown
            v-model="selectedView"
            :items="views"
            :label="$t('view')"
            item-text="name"
            item-value="id"
            color="white"
            hide-details
          />
        </v-col>
      </template>
    </page-toolbar>

    <div :class="device.isMobile ? 'px-0 mt-2' : 'px-2 mt-2'">
      <restaurant-meals-stats v-if="selectedView === 1" :date="date" />
      <restaurant-group-meals-stats v-else-if="selectedView === 2" :date="date" />
      <restaurant-more-restaurants-stats v-else-if="selectedView === 3" :date="date" />
    </div>
  </div>
</template>

<script>
import RestaurantMealsStats from "./tabs/RestaurantMealsStats.vue";
import RestaurantGroupMealsStats from "./tabs/RestaurantGroupMealsStats.vue";
import RestaurantMoreRestaurantsStats from "./tabs/RestaurantMoreRestaurantsStats.vue";
import companyService from "@/services/company";

export default {
  name: "RestaurantStatistics",
  components: {
    RestaurantMealsStats,
    RestaurantGroupMealsStats,
    RestaurantMoreRestaurantsStats,
  },
  data() {
    return {
      selectedView: null,
      date: [
        new Date().toISOString().substr(0, 10),
        new Date().toISOString().substr(0, 10),
      ],
    };
  },
  computed: {
    views() {
      return [
        { id: 1, name: this.$t("meal_in_meals") },
        { id: 2, name: this.$t("meal_in_groops") },
        { id: 3, name: this.$t("companies_fed_by_restaurant") },
      ];
    },
  },
  methods: {
    async loadCompanies() {
      try {
        const res = await companyService.getCompanies();
        const companies = res.data || [];
        const groupCount = companies.filter((c) => c.type === "group").length;
        const nonGroupCount = companies.length - groupCount;
        this.selectedView = groupCount > nonGroupCount ? 2 : 1;
      } catch {
        this.selectedView = 1;
      }
    },
  },
  created() {
    this.loadCompanies();
  },
};
</script>
